import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state:{
        topActive:'',
        topMenu:[]
    },
    mutations:{
      getTopMenu(store,data){
        store.activeName = data.name
        if(store.topMenu.filter(a=>{return a.name == data.name}).length>0){
          store.topActive = store.topMenu.filter(a=>{return a.name == data.name})[0].name
        }else{
          store.topActive = data.name
          store.topMenu.splice(store.topMenu.length,0,data);
        }
      },
      closeCurPage(store,data){
        store.topMenu.splice(store.topMenu.findIndex(v=>{return v.name == data.name}),1);
        store.topActive = store.topMenu.length>=1?store.topMenu[store.topMenu.length-1].name:'首页'
      }
    },
    getters:{
      headerInfo(state){
        return state.topMenu
      },
      getTopActive(state){
        return state.topActive
      }
    },
    actions:{
      changeTopMenu(state,r){
        state.commit('getTopMenu',r)
      },
      closeTopMenu(state,r){
        state.commit('closeCurPage',r)
      }
    }
})

export default store